module.exports = __webpack_public_path__ + "static/media/IMG_7012 edit.22317751.jpg";